<template>
  <form-component>
    <form
      novalidate="novalidate"
      @submit.prevent="doSave"
    >
      <ul class="criteria-list">
        <li>
          <input
            id="buyer_dashboard"
            v-model="buyer_dashboard"
            name="buyer_dashboard"
            class="custom-styled-checkbox"
            type="checkbox"
          >
          <label for="buyer_dashboard">
            <span>
              Buyer Dashboard
            </span>
          </label>
          <b-form-select
            v-model="buyerDashboardOption"
            :options="dashboardOptions"
          />
        </li>
        <li>
          <input
            id="seller_dashboard"
            v-model="seller_dashboard"
            name="seller_dashboard"
            class="custom-styled-checkbox"
            type="checkbox"
          >
          <label for="seller_dashboard">
            <span>
              Seller Dashboard
            </span>
          </label>
          <b-form-select
            v-model="sellerDashboardOption"
            :options="dashboardOptions"
          />
        </li>
      </ul>

      <!-- <hr v-if="buyer_dashboard">
      <h5 v-if="buyer_dashboard">Buyer Dashboard Options:</h5>
      <p v-if="buyer_dashboard">
        Please select which items you would like to see on your buyer dashboard.
      </p>

      <ul class="criteria-list no-right" v-if="buyer_dashboard">
        <li>
          <input
            
            id="buyer_suggested_for_you"
            name="buyer_suggested_for_you"
            v-model="buyer_suggested_for_you"
            class="custom-styled-checkbox"
            type="checkbox"
          >
          <label for="buyer_suggested_for_you">
            <span>
              Suggested For You
            </span>
          </label>
        </li>
        <li>
          <input
            
            id="buyer_virginia_picks"
            name="buyer_virginia_picks"
            v-model="buyer_virginia_picks"
            class="custom-styled-checkbox"
            type="checkbox"
          >
          <label for="buyer_virginia_picks">
            <span>
              Virginia Picks
            </span>
          </label>
        </li>
        <li>
          <input
            
            id="buyer_favorites"
            name="buyer_favorites"
            v-model="buyer_favorites"
            class="custom-styled-checkbox"
            type="checkbox"
          >
          <label for="buyer_favorites">
            <span>
              Favorited
            </span>
          </label>
        </li>
      </ul> -->

      <hr v-if="seller_dashboard">
      <h5 v-if="seller_dashboard">
        Seller Dashboard Options:
      </h5>
      <p v-if="seller_dashboard">
        Please select which items you would like to see on your seller dashboard.
      </p>

      <ul
        v-if="seller_dashboard"
        class="criteria-list no-right"
      >
        <!-- <li>
          <input
            
            id="seller_solicitations"
            name="seller_solicitations"
            v-model="seller_solicitations"
            class="custom-styled-checkbox"
            type="checkbox"
          >
          <label for="seller_solicitations">
            <span>
              Solicitations
            </span>
          </label>
        </li> -->
        <li>
          <input
            id="seller_my_products"
            v-model="seller_my_products"
            name="seller_my_products"
            class="custom-styled-checkbox"
            type="checkbox"
          >
          <label for="seller_my_products">
            <span>
              My Products
            </span>
          </label>
        </li>
      </ul>

      <div
        v-if="seller_dashboard"
        class="row"
      >
        <div class="col-12">
          <input-text
            id="calendar_link"
            v-model="calendar_link"
            v-validate="{url: true}"
            name="calendar_link"
            label="Calendar Link (URL)"
            data-vv-name="calendar_link"
            data-vv-as="calendar url"
            :error="errors.first('calendar_link')"
          />
        </div>
      </div>

      <hr
        v-if="showSaveButton"
        class="hidden-modal"
      >

      <button
        v-if="showSaveButton"
        type="submit"
        class="btn btn-primary submit-btn"
      >
        <processing-text :prc="saving">
          Save Changes
        </processing-text>
      </button>
    </form>
  </form-component>
</template>

<script>
import FormComponent from '@/components/FormComponent.vue';
import ProcessingText from '@/components/ProcessingText.vue';
import InputText from '@/components/inputs/InputText.vue';
import UserClient from '@/api/UserClient';

export default {
  name: 'UserSettingsForm',
  components: {
    FormComponent,
    ProcessingText,
    InputText,
  },
  props: {
    onSave: {
      type: Function,
    },
    showSaveButton: {
      type: Boolean,
      default: true,
    },
    user: {
      type: Object,
    },
  },
  data() {
    return {
      saving: false,
      userClient: new UserClient(this.$http),

      buyer_dashboard: true,
      seller_dashboard: true,
      buyer_suggested_for_you: true,
      buyer_virginia_picks: true,
      // buyer_departments: true,
      buyer_favorites: true,
      // seller_solicitations: true,
      seller_my_products: true,
      calendar_link: '',

      // handle the dashboard selection
      buyerDashboardOption: 'default',
      sellerDashboardOption: 'secondary',
      dashboardOptions: [
        { value: '', text: 'Disabled' },
        { value: 'default', text: 'Default' },
        { value: 'secondary', text: 'Secondary' },
      ],

      // importance: 'Medium',
      // importanceOptions: {
      //   Low: 'Low',
      //   Medium: 'Medium',
      //   High: 'High',
      // },
      syncingDashboardOptions: false,
    };
  },
  computed: {
    
  },
  watch: {
    buyerDashboardOption(v) {
      this.syncDashboardOptions(true);
    },
    sellerDashboardOption(v) {
      this.syncDashboardOptions(false, true);
    },
    buyer_dashboard(v) {
      this.syncDashboardOptions();
    },
    seller_dashboard(v) {
      this.syncDashboardOptions();
    },
  },
  mounted() {
    if (this.user) {
      this.reset(this.user);
    } else if (this.$globals.user()) {
      this.reset(this.$globals.user());
    }
  },
  methods: {

    syncDashboardOptions(fromBuyerOption, fromSellerOption) {
      if (!this.syncingDashboardOptions) {
        this.syncingDashboardOptions = true;      

        setTimeout(() => {
          if (fromBuyerOption) {
            this.buyer_dashboard = this.buyerDashboardOption !== '';
          }

          if (fromSellerOption) {
            this.seller_dashboard = this.sellerDashboardOption !== '';
          }

          if (this.buyerDashboardOption === this.sellerDashboardOption) {
            // should never be the same ...
            const bothAreDefault = this.buyerDashboardOption === 'default';
            if (fromBuyerOption) {
              // keep the buying one the same
              this.sellerDashboardOption = bothAreDefault ? 'secondary' : 'default';
            } else if (fromSellerOption) {
              // keep the selling option the same
              this.buyerDashboardOption = bothAreDefault ? 'secondary' : 'default';
            }
          }

          if (this.buyer_dashboard) {
            this.buyerDashboardOption = this.sellerDashboardOption === 'default' ? 'secondary' : 'default';
          } else {
            this.buyerDashboardOption = '';
          }

          if (this.seller_dashboard) {
            this.sellerDashboardOption = this.buyerDashboardOption === 'default' ? 'secondary' : 'default';
          } else {
            this.sellerDashboardOption = '';
          }

          this.syncingDashboardOptions = false;
        }, 0);
      }
    },

    reset(user) {
      let default_dashboard = 'buyer';
      if (user && user.user_settings) {
        default_dashboard = user.user_settings.default_dashboard || 'buyer';

        this.buyer_dashboard = user.user_settings.buyer_dashboard;
        this.seller_dashboard = user.user_settings.seller_dashboard;
        this.buyer_suggested_for_you = user.user_settings.buyer_suggested_for_you;
        this.buyer_virginia_picks = user.user_settings.buyer_virginia_picks;
        // this.buyer_departments = user.user_settings.buyer_departments;
        this.buyer_favorites = user.user_settings.buyer_favorites;
        // this.seller_solicitations = user.user_settings.seller_solicitations;
        this.seller_my_products = user.user_settings.seller_my_products;
        this.calendar_link = user.user_settings.calendar_link;
      } else {
        this.buyer_dashboard = true;
        this.seller_dashboard = true;
        this.buyer_suggested_for_you = true;
        this.buyer_virginia_picks = true;
        // this.buyer_departments = true;
        this.buyer_favorites = true;
        // this.seller_solicitations = true;
        this.seller_my_products = true;
        this.calendar_link = '';
      }

      if (default_dashboard === 'buyer') {
        this.buyerDashboardOption = 'default';
        this.sellerDashboardOption = this.seller_dashboard ? 'secondary' : '';
      } else {
        this.buyerDashboardOption = this.buyer_dashboard ? 'secondary' : '';
        this.sellerDashboardOption = 'default';
      }

    },
    doSave() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.errors.clear();

          if (!this.buyer_dashboard && !this.seller_dashboard) {
            return this.$globals.showError('Please select at least one dashboard type!');
          }

          this.saving = true;

          const default_dashboard = this.buyerDashboardOption === 'default' ? 'buyer' : 'seller';

          const {
            buyer_dashboard,
            seller_dashboard,
            buyer_suggested_for_you,
            buyer_virginia_picks,
            // buyer_departments,
            buyer_favorites,
            // seller_solicitations,
            seller_my_products,
            calendar_link,
          } = this;


          const data = {
            default_dashboard,
            buyer_dashboard,
            seller_dashboard,
            buyer_suggested_for_you,
            buyer_virginia_picks,
            // buyer_departments,
            buyer_favorites,
            // seller_solicitations,
            seller_my_products,
            calendar_link,
          };

          this.userClient.setSettings(data).then(res => {
            this.saving = false;
            this.onSave(res);
          }).catch(ex => {
            this.saving = false;
            this.onSave(null, ex);
          });
        } else {
          // for outer save buttons pass back something to stop spinning
          this.$globals.scrollToFirstError(this.$validator);
          this.onSave(null, null);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.criteria-options {
  padding-top: 0;
}

h5 {
  span {
    font-weight: normal;
    opacity: 0.4;
    margin-left: 6px;
  }
}

.no-right {
  label {
    padding-right: 15px;
  }
}
</style>
